/** @jsx jsx */
import { jsx } from "@emotion/core"

import { List } from "@cd2/components"
import { format } from "date-fns"
import { LabelInfo } from "../Components/LabelInfo"
import { buildRoute, eRoutes } from "../routes"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"

type IQuote = IRecord<
  "deliveries",
  "delivery_service" | "dpd_tracking_numbers_json" | "fedexTrackingNumber" | "created_at"
> & {
  order: IRecord<"orders", "identifier">
}

interface IProps {
  id: string
  initialData?: IQuote
  renderInlineLink?: "block" | "inline"
  inline?: boolean
}

export function HoverDeliveryLoader({ id, initialData, renderInlineLink, inline }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const record = await skeem.fetchOne<IQuote>({
      deliveries: {
        attributes: [
          "delivery_service",
          "dpd_tracking_numbers_json",
          "fedexTrackingNumber",
          "created_at",
          { name: "order", attributes: ["identifier"] },
        ],
        filter: { matches: { id } },
      },
    })
    return record
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      inline={inline}
      viewLink={delivery => buildRoute(eRoutes["/deliveries/:id/preview"], { id: delivery.id })}
      renderInlineLink={renderInlineLink}
      resourceName="Delivery"
      renderHoverContentTitle={record => record.order.identifier}
      renderHoverContent={record => (
        <div>
          <List>
            <LabelInfo
              labelWidth={80}
              label="Order Identifier"
              value={record.order.identifier}
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Delivery Service"
              value={record.delivery_service}
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Tacking Number"
              value={
                record.delivery_service === "dpd"
                  ? ((record?.dpd_tracking_numbers_json as string[]) ?? []).join(", ")
                  : record.fedexTrackingNumber
              }
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Created At"
              value={record.created_at ? format(new Date(record.created_at), "dd/MM/yy p") : "-"}
              inline
            />
          </List>
        </div>
      )}
      renderTarget={record => <span>{record.order.identifier}</span>}
    />
  )
}
